<template>
    <Layout>
        <template v-slot:title>
            <h1>Inactive Users (Last visit more than 1.5 years)</h1>
            <div class="pt-2 text-red text-bold">Records found: {{ totalItems }}</div>
        </template>
        <template v-slot:content>
            <Loader v-if="isLoading"></Loader>
            <div class="row mb-2 d-flex">
                <div class="col-sm-6 col-md-4 col-xl-3">
                    <form @submit.prevent="onSearch" class="input-group btn-inline">
                        <input
                            v-model="keyword"
                            name="table-search-inactive"
                            class="form-control float-right"
                            placeholder="Search"
                            type="text"
                        />
                        <div class="input-group-append">
                            <button type="submit" class="btn btn-default">
                                <f-icon icon="search" />
                            </button>
                        </div>
                    </form>
                </div>
                <div class="mr-2 ml-auto">
                    <button v-if="users.length > 0" @click.stop="deleteAll" class="btn btn-danger">Delete All</button>
                </div>
            </div>

            <div v-if="users.length > 0">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="table-responsive tbq-table-responsive">
                            <table class="table tbq-table">
                                <thead>
                                    <tr>
                                        <th nowrap>Name</th>
                                        <th nowrap>Email</th>
                                        <th nowrap>Role</th>
                                        <th nowrap>Last Visit</th>
                                        <th nowrap class="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in users" :key="index">
                                        <td class="align-middle" nowrap>
                                            <a
                                                @click="setUserSelected(item)"
                                                :data-target="'#modal-user-detail'"
                                                data-toggle="modal"
                                                href="#"
                                            >
                                                {{ item.name || '-' }}
                                            </a>
                                            <small class="d-flex flex-column">
                                                <span v-if="item.school_name || item.school_org_no">
                                                    {{
                                                        item.school_name && item.school_org_no
                                                            ? `${item.school_name} - ${item.school_org_no}`
                                                            : item.school_name || item.school_org_no
                                                    }}
                                                </span>
                                            </small>
                                        </td>
                                        <td class="align-middle" nowrap>{{ item.email }}</td>
                                        <td class="align-middle" nowrap>{{ item.role_label }}</td>
                                        <td class="align-middle" nowrap>
                                            {{ item.last_visit ? item.last_visit_readable : '-' }}
                                        </td>
                                        <td class="align-middle text-center" nowrap style="max-width: 10%">
                                            <EditIcon
                                                @click="setUserSelected(item)"
                                                :data-target="'#modal-user-detail'"
                                                data-toggle="modal"
                                                class="text-info cursor-pointer mr-3"
                                                size="1.3x"
                                            ></EditIcon>
                                            <Trash2Icon
                                                @click.stop="deleteUser(item._id.$oid)"
                                                class="text-danger cursor-pointer"
                                                title="Delete user"
                                                size="1.3x"
                                            ></Trash2Icon>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-12 my-3">
                            <Paginator
                                @change="onPageChange"
                                :current-page="currentPage"
                                :page-count="pageCount"
                                :total-items="totalItems"
                            />
                        </div>
                    </div>

                    <FormModal @click="onModalCloseHandler" :user="selectUser" id="modal-user-detail" />

                    <div
                        class="modal fade"
                        ref="modal"
                        id="progress-modal"
                        data-backdrop="static"
                        data-keyboard="false"
                    >
                        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                            <div class="modal-content">
                                <div class="progress">
                                    <div
                                        class="progress-bar progress-bar-striped bg-success progress-bar-animated"
                                        role="progressbar"
                                        :style="`width: ${calProgress}%`"
                                        :aria-valuenow="calProgress"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <EmptyList v-else :label="emptyLabel" />
        </template>
    </Layout>
</template>

<script>
import $ from 'jquery'
import { mapGetters } from 'vuex'
import Layout from '@/components/Layout'
import Loader from '@/components/Loader'
import helpers from '@/service/helpers'
import Url from '@/service/url'
import Paginator from '@/components/Paginator'
import { EditIcon, Trash2Icon } from 'vue-feather-icons'
import FormModal from '@/components/user/FormModal'
import EmptyList from '@/components/EmptyList'

export default {
    name: 'user-index',

    components: {
        Layout,
        Loader,
        Paginator,
        EditIcon,
        Trash2Icon,
        FormModal,
        EmptyList
    },

    data() {
        return {
            keyword: '',
            isLoading: false,
            users: [],
            currentPage: 1,
            pageCount: 0,
            totalItems: 0,
            preventPageChange: false,
            selectUser: null,
            emptyLabel: 'No user found',
            progress: 0,
            totalProgress: 0
        }
    },

    watch: {
        $route() {
            var url = new Url()
            this.findMany(url.buildQuery())
        }
    },

    computed: {
        ...mapGetters('user', {
            roles: 'roles'
        }),

        calProgress() {
            return (this.progress / this.totalProgress) * 100
        }
    },

    created() {
        var url = new Url()
        this.findMany(url.buildQuery())

        var query = url.getQuery()

        if (query.keyword) {
            this.keyword = query.keyword
        }
    },

    methods: {
        ...helpers,
        onPageChange(page) {
            var url = new Url()

            if (this.preventPageChange) {
                return setTimeout(() => {
                    this.preventPageChange = false
                }, 500)
            }

            this.$router.push({
                name: this.$router.currentRoute.name,
                query: url.buildQuery({ page })
            })
        },

        onSearch() {
            var url = new Url()
            this.$router.push({
                name: this.$router.currentRoute.name,
                query: url.buildQuery({
                    page: 1,
                    keyword: this.keyword
                })
            })
        },

        findMany(params) {
            this.isLoading = true

            this.$store
                .dispatch('user/findInactiveUsers', params)
                .then(res => {
                    const data = res.data.data
                    this.pageCount = parseInt(data.page_count)
                    this.currentPage = parseInt(data.current_page)
                    this.totalItems = parseInt(data.total)

                    data.data.map((userData, index) => {
                        this.roles.map(roleData => {
                            if (userData.role === roleData.value) {
                                data.data[index]['role_label'] = roleData.label
                            }
                        })
                    })

                    this.users = data.data

                    this.isLoading = false

                    if (this.keyword !== '' && this.users.length === 0) {
                        this.emptyLabel = `
                        <p class="text-center text-muted">Your search <b class="text-dark">"${this.keyword}"</b> did not match.</p>
                        <p class="text-center text-muted">Please, try another keyword</p>
                    `
                    }
                })
                .catch(() => {
                    this.isLoading = false
                    window.shout.error('Users not found')
                })
        },

        setUserSelected(user) {
            const userSelect = Object.assign({}, user, { loading: true })
            this.selectUser = userSelect

            this.$store
                .dispatch('user/findUserDetail', user['_id']['$oid'])
                .then(res => {
                    const orders = res.data.data.user_detail.orders
                    let totalOrderValue = 0

                    for (let index in orders) {
                        totalOrderValue = totalOrderValue + parseFloat(orders[index]['amount'])
                    }

                    this.selectUser = Object.assign(
                        {},
                        userSelect,
                        { total_order_value: totalOrderValue },
                        { user_detail: res.data.data.user_detail },
                        { loading: false }
                    )
                })
                .catch(err => {
                    if (err) {
                        this.selectUser = Object.assign({}, userSelect, { loading: false })
                    }
                })
        },

        deleteUser(id) {
            this.$vueConfirm.confirm(
                {
                    message: `Are you sure?`,
                    button: {
                        no: 'No',
                        yes: 'Yes'
                    }
                },
                confirm => {
                    if (confirm == true) {
                        this.isLoading = true
                        this.$store
                            .dispatch('user/adminDeleteUser', {
                                id: id
                            })
                            .then(() => {
                                this.isLoading = false
                                this.findMany()
                                window.shout.success('Delete user success.')
                            })
                            .catch(() => {
                                this.isLoading = false
                                window.shout.error('Something wrong!')
                            })
                    }
                }
            )
        },

        async deleteAll() {
            this.$vueConfirm.confirm(
                {
                    message: `Are you sure?`,
                    button: {
                        no: 'No',
                        yes: 'Yes'
                    }
                },
                async confirm => {
                    if (confirm == true) {
                        $('#progress-modal').modal('show')
                        this.progress = 0
                        this.totalProgress = 0

                        try {
                            const res = await this.$store.dispatch('user/findInactiveUsers', { is_get_all: true })
                            const data = res.data.data
                            this.totalProgress = data.length

                            const promises = data.map((user, index) => {
                                return new Promise(resolve => {
                                    setTimeout(() => {
                                        this.$store
                                            .dispatch('user/adminDeleteUser', {
                                                id: user['_id']['$oid']
                                            })
                                            .then(() => {
                                                ++this.progress
                                                resolve()
                                            })
                                    }, 150 * index)
                                })
                            })

                            await Promise.all(promises)

                            setTimeout(() => {
                                $('#progress-modal').modal('hide')
                                this.findMany()
                                window.shout.success('Delete user success.')
                            }, 500)
                        } catch (error) {
                            $('#progress-modal').modal('hide')
                            window.shout.error('Something wrong!')
                            console.error(error)
                        }
                    }
                }
            )
        },

        onModalCloseHandler() {
            this.selectUser = null
        }
    }
}
</script>



